<fieldset class="multi-select-list">
  <legend *ngIf="title">
    <h3>{{ title  }}</h3>
  </legend>
  <mat-list>
    <mat-list-item *ngFor="let itemControl of formArray.controls; index as i">
      <section class="form-field">
        <app-autocomplete
          [control]="$any(itemControl)"
          [list]="selectableItems"
          (changeEvent)="onItemChange()"
          [label]="label"
          [errorMsg]="errorMsg"
        >
        </app-autocomplete>
      </section>

      <button
        type="button"
        mat-icon-button
        color="primary"
        [disabled]="!canRemove || isDisabled"
        (click)="removeItem(i)"
      >
        <mat-icon aria-label="delete">delete</mat-icon>
      </button>
    </mat-list-item>
    <mat-list-item>
      <button
        type="button"
        mat-icon-button
        color="primary"
        [disabled]="isDisabled"
        (click)="addItem()"
      >
        <mat-icon aria-label="Add">add</mat-icon>
      </button>
    </mat-list-item>
  </mat-list>
</fieldset>
